import { IconWrapper } from '../runtime';
export default IconWrapper('recover', false, function (h, props) {
  return h("svg", {
    "attrs": {
      "width": props.size,
      "height": props.size,
      "viewBox": "0 0 16 16",
      "fill": "none"
    }
  }, [h("path", {
    "attrs": {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      "d": "M14.6689 3.49657C15.0915 3.77727 15.0844 4.40032 14.6556 4.67139L11.074 6.93512C10.6079 7.22972 9.99999 6.89479 10 6.34339C10.0001 1.69127 10 5.83855 10.0001 1.70092C10.0001 1.14238 10.6221 0.808808 11.0874 1.11783L14.6689 3.49657Z",
      "fill": props.colors[0],
      "vector-effect": "non-scaling-stroke"
    }
  }), h("path", {
    "attrs": {
      "d": "M12 3.99976H6.875C4.04454 3.99976 1.75 6.2943 1.75 9.12476V9.12476C1.75 11.9552 4.04454 14.2498 6.875 14.2498H10.25",
      "stroke": props.colors[0],
      "stroke-width": props.strokeWidth,
      "stroke-linecap": props.strokeLinecap,
      "stroke-linejoin": props.strokeLinejoin,
      "vector-effect": "non-scaling-stroke"
    }
  })]);
});